<template>
  <div class="footer" v-show="isShow">
    <!-- 大倉文庫&nbsp;&nbsp;
    <a target="_blank" href="https://beian.miit.gov.cn/">
      京ICP備09072562號-7&nbsp;&nbsp;</a
    >
    <a
      href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802043812"
      rel="noreferrer"
      target="_blank"
      >京公網安備11010802043812&nbsp;&nbsp;</a
    >
    版權所有@北京大學出版社 -->
    <div class="foot">
      <ul data-v-4a8d8ce4="" class="banquan">
        <li data-v-4a8d8ce4="">反饋意見：digital2@pup.cn</li>
        <li data-v-4a8d8ce4="">
          <a
            data-v-4a8d8ce4=""
            target="_blank"
            href="https://beian.miit.gov.cn/"
            ><span data-v-4a8d8ce4="">京ICP備09072562號-7</span></a
          >
        </li>
        <li data-v-4a8d8ce4="">京公網安備11010802043812號</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showDrawer: false,
      list: [{
        path: '/',
        title: '首頁'
      }, {
        path: '/show',
        title: '映像-書影'
      }, {
        path: '/dddd',
        title: '尋蹤-書目'
      }, {
        path: '/analysis',
        title: '文本分析'
      }, {
        path: '/ddddd',
        title: '大仓故事'
      }]
    }
  },
  created: function () {
    this.isShow = this.$route.name != 'WenKu' ? true : false

  },
  methods: {
    showMenu () {
      this.showDrawer = true
    },
    toPath (path) {
      this.$router.push({
        path: path
      })
    }
  }
}
</script>

<style scoped>
.footer {
  width: 100%;
  height: 50px;
  position: fixed;
  bottom: 0;
  left: 0;

  /* z-index: 999999999999; */
  z-index: 9999;
  /* margin-top: -4px; */
  border-top: 4px solid #aa1d1f;
  background: url(../../static/home/footer_bg.png) no-repeat;
  background-size: cover;

  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  text-align: center;

  /* line-height: 50px; */
}
.foot {
  width: 650px;
  margin: 0 auto;
}
.footer ul {
  width: 650px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer ul li {
  width: 33.3%;
  height: 16px;
  display: block;
  font-size: 14px;
  /* color: #fff; */
  text-align: center;
  /* font-weight: 700; */
}
.footer ul li:not(:last-child) {
  border-right: 1px solid rgba(255, 255, 255, 0.5);
}
.footer a {
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  text-align: center;
  /* line-height: 50px; */
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue